import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import cn from "classnames";
import { useBreakpointBelowLg } from "../../../hooks/useBreakpointBelowLg";
import { useMeCore } from "../../../cores/me";
import { PanelWembii } from "../PanelWembii";
import { useGlobalCore } from "../../../cores/globals";
import SidebarNavigation from "./SidebarNavigation";
import SidebarAdminRoutes from "./SidebarAdminRoutes";
import SidebarResellerRoutes from "./SidebarResellerRoutes";
import SidebarUserRoutes from "./SidebarUserRoutes";

const Sidebar = () => {
  const { isAdmin, isReseller } = useMeCore();
  const { collapseSideBar, setCollapseSideBar, isDarkMode, setOpenSideBar } =
    useGlobalCore();
  const isMobileSidebar = useBreakpointBelowLg();

  return (
    <PanelWembii
      className={cn("h-100 wembii-sidebar", {
        sidebarExpanded: !collapseSideBar,
        sidebarCollaped: collapseSideBar,
      })}
      backgroundColor={isDarkMode ? "#161B22" : undefined}
      onMouseEnter={() =>
        !isMobileSidebar && setCollapseSideBar(false)
      }
      onMouseLeave={() =>
        !isMobileSidebar && setCollapseSideBar(true)
      }
    >
      <div className="p-3 flex-grow-1 sidebar-inner-scroll">
        <div className="d-flex d-lg-none justify-content-end mb-2">
          <button
            type="button"
            className="border-0 rounded d-flex align-items-center justify-content-center p-2 sidebar-mobile-close"
            style={{
              minWidth: 44,
              minHeight: 44,
              backgroundColor: isDarkMode ? "#161B22" : "white",
              border: isDarkMode ? "1px solid #30363D" : "none",
            }}
            onClick={() => setOpenSideBar(false)}
            aria-label="Cerrar menú"
          >
            <FontAwesomeIcon
              icon={["fas", "times"]}
              className={isDarkMode ? "text-light" : "text-secondary"}
              size="lg"
            />
          </button>
        </div>
        <SidebarNavigation />

        {!isAdmin && <SidebarUserRoutes collapseSideBar={collapseSideBar} />}

        {isReseller && (
          <SidebarResellerRoutes collapseSideBar={collapseSideBar} />
        )}
        {isAdmin && <SidebarAdminRoutes collapseSideBar={collapseSideBar} />}
      </div>
    </PanelWembii>
  );
};

export default React.memo(Sidebar);
